export const POSITION_SENDER_OVERVIEW = [0, 9, 19, 29];
